import { useContext } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Flex, Text } from 'rebass'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { DataContext } from '../../contexts/dataContext'
import { lang } from '../../utils/lang'

const Footer = styled(Flex)`
  width: 100vw;
  height: 4rem;
  background-color: ${(props) => props.theme.colors.pebbleGray};
  color: ${(props) => props.theme.colors.black};
  font-size: ${(props) => (props.ui === 'fa' ? '.9rem' : '0.8rem')};
  margin: ${(props) =>
    props.modal
      ? '0 0 0 0'
      : props.ui === 'en'
      ? '0 0 0 -1.25rem'
      : '0 -1.25rem 0 0'};
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-end;
  padding: 1rem;
  position: ${(props) =>
    props.modal || props.intro === 'open' ? 'relative' : 'absolute'};
  bottom: 0;
  display: ${(props) =>
    !props.map || props.modal
      ? 'flex'
      : 'none'}; // shows footer in intro and modal but not on map
  z-index: 20;
  ${Mq.xs} {
    justify-content: space-between;
    align-items: center;
    height: 1.8rem;
    flex-direction: row;
    margin: 0;
    position: ${(props) =>
      props.intro === 'open' || props.map ? 'absolute' : 'relative'};
    display: ${(props) => (props.modal || !props.map ? 'none' : 'flex')};
  }
`

const CreditText = styled(Text)`
  color: ${(props) => props.theme.colors.steelBlue};
  font-size: 0.8rem;
  span {
    font-weight: 700;
  }
`

const FooterBar = ({ modal, map }) => {
  const { intro, ui } = useContext(DataContext)
  const dir = ui === 'en' ? 'ltr' : 'rtl'
  return (
    <Footer px={3} intro={intro} modal={modal} map={map} ui={ui} dir={dir}>
      <Text>
        {lang[ui]['Copyright']} &#169;2024 {lang[ui]['ABC']}
      </Text>
      <CreditText ui={ui}>
        Built by: <span>Graphicacy</span>
      </CreditText>
    </Footer>
  )
}

export default FooterBar

FooterBar.propTypes = {
  modal: PropTypes.bool,
  map: PropTypes.bool
}
